<script>
export default {
  data() {
    return {
      dropdownActive: false,
      itemHeight: 34
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyEvents);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyEvents);
  },
  methods: {
    handleKeyEvents(e) {
      if  (this.$refs.elem && this.dropdownActive && (e.code == 'ArrowDown' || e.code == 'ArrowUp')) {
        let highlight = this.$refs.elem.$el.querySelector('.multiselect__option--highlight');
        let container = highlight.closest('ul.multiselect__content');
        
        if (e.code == 'ArrowDown' && highlight.parentNode.offsetTop + this.itemHeight > container.offsetHeight + container.scrollTop) {
          container.scrollTop = highlight.parentNode.offsetTop - container.offsetHeight + this.itemHeight;
        } else if (e.code == 'ArrowUp' && highlight.parentNode.offsetTop < container.scrollTop) {
          container.scrollTop = highlight.parentNode.offsetTop;
        }
      }
    }
  }
}
</script>